import angular from "angular";

angular
    .module('ui-common')
    .factory('TemperatureUtilsService', TemperatureUtilsService);

function TemperatureUtilsService() {
    const service = {
        getTemperatureC: function (report) {
            if (!report) {
                return null;
            }
            return report.temperatureValueC !== null && report.temperatureValueC !== undefined ? report.temperatureValueC : report.temperatureC;
        },
        getTemperatureF: function (report) {
            if (!report) {
                return null;
            }
            return report.temperatureValueF !== null && report.temperatureValueF !== undefined ? report.temperatureValueF : report.temperatureF;
        },
        getFilteredPropertyValue: function (report, property) {
            if (!report) {
                return null;
            }
            if (property === 'temperatureC' || property === 'temperatureValueC') {
                return service.getTemperatureC(report);
            }
            if (property === 'temperatureF' || property === 'temperatureValueF') {
                return service.getTemperatureF(report);
            }
            return report[property];
        },
    };
    return service;
}
